import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor() { }

  triggerFormValidation(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.triggerFormValidation(control);
      }
    });
  }

  triggerFormValidationOnArray(formArray: FormArray) {
    formArray.controls.forEach(item => {
      if (item instanceof FormGroup) {
        const formGroup = item as FormGroup;
        this.triggerFormValidation(formGroup);
      } else if (item instanceof FormControl) {
        const control = item as FormControl;
        control.markAsTouched({ onlySelf: true });
      }
    });
  }



  nonEmpty(control: AbstractControl) {
    return (control != null && control.value != null && control.value != '');
  }

}
